export default "__VITE_ASSET__CGRM8gcY__"